import { FieldResponse, FieldsAPI } from '@cibo/core'
import { QUERY_KEY as LANDMANAGER_QUERY_KEY } from '@cibo/landmanager'
import { QueryClient, useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'
import { PROGRAMS_QUERY_KEY } from './queryKey'

type OnSuccessFunction = (
  data: AxiosResponse<FieldResponse>,
  variables: {
    fieldId: string
    programId: string
  }
) => unknown

export const forceCommitInvalidate = (
  queryClient: QueryClient,
  programId: string,
  fieldIds: string[]
) => {
  queryClient.invalidateQueries([LANDMANAGER_QUERY_KEY.FIELDS_PAGINATED])
  queryClient.invalidateQueries([PROGRAMS_QUERY_KEY.PROGRAMS])
  queryClient.invalidateQueries([PROGRAMS_QUERY_KEY.OPPORTUNITIES])
  queryClient.invalidateQueries([PROGRAMS_QUERY_KEY.PROGRAMS, programId])
  fieldIds.forEach(fieldId => {
    queryClient.invalidateQueries([LANDMANAGER_QUERY_KEY.FIELDS, fieldId])
  })
}

export const useForceCommitField = (onSuccessFunction?: OnSuccessFunction) => {
  const queryClient = useQueryClient()

  const onSuccess: OnSuccessFunction = onSuccessFunction
    ? onSuccessFunction
    : (response, { fieldId, programId }) => {
        forceCommitInvalidate(queryClient, programId, [fieldId])
      }

  return useMutation(
    ({ fieldId, programId }: { fieldId: string; programId: string }) =>
      FieldsAPI.forceCommitField(fieldId, programId),
    {
      onSuccess,
    }
  )
}
